import { render, staticRenderFns } from "./Risque.vue?vue&type=template&id=4cad5dc6&"
import script from "./Risque.vue?vue&type=script&lang=js&"
export * from "./Risque.vue?vue&type=script&lang=js&"
import style0 from "./Risque.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports